import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from 'assets/images/logo.png';
import './doubleAuthentification.style.scss';
import DoubleAuthentificationForm from './form';
import LangSwitch from 'components/MainNav/LangSwitch';

const DoubleAuthentification = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const twoFaToken = searchParams.get('2fa_token');

  // No token detected redirect login
  useEffect(() => {
    if (!twoFaToken) {
      navigate('/login');
    }
  }, [twoFaToken, navigate]);

  if (!twoFaToken) {
    return null;
  }

  return (
    <div className="Login">
      <div className="form">
        <div className="d-flex-end langSwitch">
          <LangSwitch />
        </div>
        <div className="logoContainer">
          <div className="recenterLogo logo m-auto d-block">
            <img className="resizeLogo" src={logo} alt="logo assolia" />
          </div>
        </div>
        <div className="container">
          <p className="text-center title">{t('form.doubleAuthentificationTitle')}</p>
          <DoubleAuthentificationForm />
        </div>
      </div>
      <div className="img" />
    </div>
  );
};

export default DoubleAuthentification;
